export default (params) => ({
  trigger: {
    name: 'service_accessory_overlays.select_item',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'wall_mount_selector_recommendations',
          'stacking_kit_overlay_recommendations',
        ],
      },
    },
    event: {
      name: 'add_item',
      params: {
        list: 'service',
      },
    },
  },
});
